import { AvatarFeaturesModel } from '../types/CoveyTownSocket';

/**
 * Contains all the data for different avatar options. Used to store features for a player
 */
export default class AvatarFeatures {
  private _baseSprite: string;

  private _hairColor: string;

  private _skinColor: string;

  private _accessories: string[];

  // Skin color order: pale, light, tan, dark
  public static readonly SKIN_COLOR_OPTIONS = ['#fdf5e2', '#ffd6a4', '#C68642', '#8D5524'];

  // Hair color order: black, red, white, blonde
  public static readonly HAIR_COLOR_OPTIONS = ['#221e32', '#9a3c11', '#fbf8eb', '#f5ec8d'];

  public static readonly HAIR_STYLE_OPTIONS = ['long', 'short'];

  public static readonly ACCESSORY_OPTIONS = ['glasses', 'headphones', 'bow'];

  constructor(baseSprite: string, hairColor: string, skinColor: string, accessories: string[]) {
    this._baseSprite = baseSprite;
    this._hairColor = hairColor;
    this._skinColor = skinColor;
    this._accessories = accessories;
  }

  set baseSprite(newBaseSprite: string) {
    if (newBaseSprite === 'short' || newBaseSprite === 'long') {
      this._baseSprite = newBaseSprite;
    } else {
      throw Error('Unsupported base sprite: ' + newBaseSprite);
    }
  }

  get baseSprite(): string {
    return this._baseSprite;
  }

  set hairColor(newHairColor: string) {
    if (AvatarFeatures.HAIR_COLOR_OPTIONS.includes(newHairColor)) {
      this._hairColor = newHairColor;
    } else {
      throw Error('Unsupported hair color: ' + newHairColor);
    }
  }

  get hairColor(): string {
    return this._hairColor;
  }

  set skinColor(newSkinColor: string) {
    if (AvatarFeatures.SKIN_COLOR_OPTIONS.includes(newSkinColor)) {
      this._skinColor = newSkinColor;
    } else {
      throw Error('Unsupported skin color: ' + newSkinColor);
    }
  }

  get skinColor(): string {
    return this._skinColor;
  }

  set accessories(newAccessories: string[]) {
    for (let i = 0; i < newAccessories.length; i++) {
      if (!AvatarFeatures.ACCESSORY_OPTIONS.includes(newAccessories[i])) {
        throw Error('Unsupported accessories: ' + newAccessories[i]);
      }
    }
    this._accessories = newAccessories;
  }

  get accessories(): string[] {
    return this._accessories;
  }

  toAvatarModel(): AvatarFeaturesModel {
    return {
      baseSprite: this.baseSprite,
      hairColor: this.hairColor,
      skinColor: this.skinColor,
      accessories: this.accessories,
    };
  }
}
